export {MailboxesIdsSingleton as default};

/**
* Mailboxes IDS
*
* Provides a set of helper methods to manipulate Mailboxes IDS
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class MailboxesIds
{
  /**
   * Transforms an array of mailbox ids to string
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {Array} ids array of ids
   *
   * @return {string} sorted id string
   */
  getIdsAsString(ids) {
    let sorted = this.sortIds(ids);
    let first  = sorted.shift();
    let last   = first;
    let out    = [];

    sorted.forEach(id => {
      if (last + 1 === id) {
        last = id;
        return;
      }

      out.push(first + (last === first ? '' : (':' + last)));
      first = last = id;
    });

    out.push(first + (last === first ? '' : (':' + last)));
    return out.join(',');
  }

  /**
   * Transforms an string if IDs in a array
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {String} string id string
   *
   * @return {Array} Array of ids
   */
  getIdsAsArray(string) {
    var out = [];

    string.trim().split(',').forEach(function(e) {
      var i, r = e.split(':');
      if (r.length === 1) {
          out.push(Number(e));
          return;
      }

      for (i = Number(r[0]); i <= Number(r[1]); ++i) {
        out.push(Number(i));
      }
    });

    return out;
  }

  /**
   * sorts an array of ids
   *
   * @private
   *
   * @since 7.0.0
   *
   * @param {Array} ids array of ids
   *
   * @return {Array} sorted array
   */
  sortIds(ids) {
    ids = ids.map(function(v) {
      return parseInt(v, 10);
    });

    return ids.sort(function(a, b) {
      return (a > b) ? 1 : ((a < b) ? -1 : 0);
    });
  }
}

/**
 * @type {MailboxesIds}
 */
const MailboxesIdsSingleton = new MailboxesIds();